import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';

Vue.use(Vuex);

const modules = {};

(r =>
  r.keys().forEach(key => {
    modules[key.match(/\/(.+?)\.js$/)[1]] = r(key).default;
  }))(require.context('./modules', true, /\.js$/));
export default new Vuex.Store({
  modules
});



// WEBPACK FOOTER //
// ./src/store/index.js